<template>
  <zen-one :showuserinfo="false" :title="'Welcome to ' + $page.props.app_name">
    
    <w-flex class="grow justify-space-betweenx basis-zero">
    <z-dashboard-item 

      class="box sh1 mb3" 
      icon="fal fa-calendar" 
      icon-color="orange-dark1" 
      header='<span class="success text-bold">45</span> / 90'
      title='PBD : Pentaksiran Bilik Darjah'
      subtitle='<span class="primary">Tarikh Tutup Taksiran : 21 Oktober 2021</span> '
    >
      <w-tag color="primary" bg-color="light-blue-5" class="sh1">
        <w-icon class="mr1" sm>
          fal fa-calendar
        </w-icon>
        35 Hari
      </w-tag>

      <w-tag color="white" bg-color="error-dark1" class="ml1 sh1">
        <w-icon class="mr1" sm>
          fal fa-book
        </w-icon>
        35 Hari
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item class="box sh1 ml3 mb3" :use-icon="false" image='' text='55' title='MBK: Murid Berkeperluan Khas' subtitle='Bilangan murid berkeperluan khas'>
    Lelaki: <span class="primary">35</span> Perempuan: <span class="pink">20</span> 
    </z-dashboard-item>
    </w-flex>

    <w-flex class="grow basis-zero">
    <z-dashboard-item 
      class="box sh1" 
      icon="fal fa-bug" 
      icon-color="blue-grey" 
      header='<i class="fal fa-bug blue-grey-light4"> </i> Ralat' 
      title='Ralat'
    >
    <div style="overflow: hidden">
      <w-button class="mb2" @click="showCard = !showCard" icon="fal fa-bug">
        {{ showCard ? 'Sorok' : 'Papar' }} Bil Ralat
      </w-button>
      <w-transition-slide left>
        <w-card v-if="showCard" class="white--bg">
          <span class="red-dark3"><em>Tiada Ralat</em></span>
        </w-card>
      </w-transition-slide>
    </div>
    </z-dashboard-item>

    <z-dashboard-item class="box ml3 sh1" :use-icon="false" image="/images/avatar.png" header='<span class="text-bold primary">Murid Contoh</span>' title="Penjejak Badai" subtitle="Anak Murid Tanpa Nama" >
      <w-tag color="white" bg-color="indigo-dark1" class="sh1" tile>
        <w-icon class="mr1" sm>
          fal fa-calendar
        </w-icon>
        Kehadiran Penuh
      </w-tag>

      <w-tag color="white" bg-color="indigo-dark2" class="sh1" tile>
        <w-icon class="mr1" sm>
          fal fa-book
        </w-icon>
        Augerah Nilam
      </w-tag>

      <w-tag color="white" bg-color="indigo-dark3" class="sh1" tile>
        <w-icon class="mr1" sm>
          fal fa-graduation-cap
        </w-icon>
        Cemerlang
      </w-tag>
    </z-dashboard-item>
    <z-dashboard-item class="box ml3 sh1" :use-icon="false" :use-slot="true" title="Saya Juga Menyokong Graf" subtitle="Kadar Pecahan Kaca">
      <template #zdileftbox>
        <div style="height:80px;width: 80px; display: flex;flex-direction:column;">
        <vue3-chart-js
            :id="doughnutChart.id"
            :type="doughnutChart.type"
            :data="doughnutChart.data"
            :options="doughnutChart.options"
            @before-render="beforeRenderLogic"
        ></vue3-chart-js>
        </div>
      </template>
    </z-dashboard-item>
    </w-flex>

    <w-card class="white--bg mt3 sh2" title="Conteng">
    <template #title>
      <w-toolbar>
        <div class="title4">
          <w-icon
          class="primary size--md"
          >
            fal fa-user
          </w-icon> Apa Khabar {{ $page.props.auth.user.name }}!</div>
        <div class="spacer"></div>
        <span class="ml2">
          <w-icon>
          fal fa-sort
          </w-icon>
        </span>
      </w-toolbar>
    </template>

    <w-image
      src="/images/sample/wave2.png"
      
      height="200"
      width="100%"
    >
    </w-image>



    

    <p class="justify">
    <strong class="primary">Penjejak Badai</strong> adalah salah satu daripada watak utama dalam cerita ini. Dia adalah anak murid Wira Utama yang mewarisi  Hikmat <em>TENDANGAN ANGIN PUYUH</em>. Hikmat ini adalah hikmat yang mementingkan kepantasan dan kelincahan gerak tendangan. Sesiapa yang mahir dengan hikmat ini juga secara tidak langsung akan dapat melayangkan dirinya diudara dengan sesuka hatinya
    Hikmat Penjejak Badai mempunyai kepantasan yang tak terhingga.<br /><br />
    </p>
    <p>
    Diantara Hikmat yang dikuasai oleh Penjejak Badai adalah:-<br /><br />
    </p>
    <p>
    <ol class="ml5">
      <li>Tendangan Angin Puyuh</li>
      <li>Badai Lalu Bangunan Runtuh</li>
      <li>Angin Menderu Hujan Mencurah</li>
      <li>Tendangan Keramat Badai</li>
      <li>Angin Kencang Dengan Hujan Lebat</li>
      <li>Gaya Angin Menyapu Sisa Awan</li>
    </ol>
    <br /><br />
    </p>

    <w-card class="white--bg" content-class="pa0">
      <template #title>
        Maklumat Saya
      </template>

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form
          class="px8 pt2 pb12"
          v-model="form.valid"
          v-model:errors-count="form.errorsCount"
          @validate="onValidate"
          @success="onSuccess">

          <w-input
            required
            label="Nama Penuh"
            :validators="[validators.required]">
          </w-input>

          <w-input
            class="mt3"
            required
            label="Nama Samaran"
            :validators="[validators.required]">
          </w-input>

          <w-input
            class="mt3"
            disabled
            required
            label="ID Pengguna"
            :validators="[validators.required]">
          </w-input>

          <w-flex class="mt4" wrap align-center justify-end>
            <w-checkbox
              required
              :validators="[validators.consent]">
              Saya Setuju
            </w-checkbox>

            <div class="spacer" />

            <w-button
              class="my1 mr2"
              bg-color="warning"
              type="reset"
              @click="form.submitted = form.sent = false">
              Reset
            </w-button>

            <w-button
              class="my1"
              type="submit"
              :disabled="form.valid === false"
              :loading="form.submitted && !form.sent">
              Hantar
            </w-button>
          </w-flex>
        </w-form>

        <w-notification
          v-model="form.sent"
          success
          transition="bounce"
          absolute
          plain
          round
          bottom>
          Borang telah berjaya dihantar
        </w-notification>
      </w-card>
    </w-card>
  </zen-one>
</template>

<script>

import ZenOne from '@/Shared/ZenOne'
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs,
  ZenOne
},
  setup () {
    const doughnutChart = {
      id: 'doughnut',
      type: 'doughnut',
      data: {
        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            backgroundColor: [
              '#37479e',
              '#2f3d88',
              '#273371',
              '#1f285a'
            ],
            data: [40, 20, 80, 10]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }
  
    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}   
    }    

    return {
      doughnutChart,
      beforeRenderLogic
    }
  },
data() {
    return {
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
  showCard: false,
}},
methods: {
  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
}
}

</script>

<style>


</style>